<div *ngIf="involvedCompanies != null && involvedCompanies.length > 1">
  <div
    *ngFor="let company of involvedCompanies; let last = last"
    class="bottom-space"
  >
    <mat-card class="mat-elevation-z0">
      <customer-project-info-one
        [inputCompany]="company"
        [inputProduct]="inputProduct"
        [pmsColorAdded]="pmsColorAdded"
        (update)="customerInfoChanged()"
      ></customer-project-info-one>
    </mat-card>
  </div>
</div>
<div *ngIf="involvedCompanies != null && involvedCompanies.length === 1">
  <customer-project-info-one
    [inputCompany]="involvedCompanies[0]"
    [inputProduct]="inputProduct"
    [pmsColorAdded]="pmsColorAdded"
    (update)="customerInfoChanged()"
  ></customer-project-info-one>
</div>
